import React, { useState } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Edit, TabbedForm, TextInput, useCreatePath, useRedirect } from 'react-admin';

import { editContainerStyles, shsButtonStyles } from 'src/styles';
import ShsFormToolbar from 'src/components/common/ShsFormToolbar';
import { ShsButton, ShsReturnButton, WithRole } from 'src/components/common';
import {
    CenterDepartment,
    CenterLessonsDuration,
    CenterLessonsPlace,
    CenterWorkingHours,
    GeneralCenterInfo
} from 'src/components/EducationalCenters/FieldGroups';
import { centerDefaultValues, CenterFormFields } from 'src/constants/centers';
import { getSchoolLessons } from 'src/utils/centers';
import { DeleteEducationCenterModal } from './modals/DeleteEducationCenterModal';
import { UserRole } from '../../auth/types';
import { ReactComponent as DeleteIcon } from 'src/assets/trash-can.svg';

export const EducationalCenterEdit: React.FC = () => {
    const redirect = useRedirect();
    const createPath = useCreatePath();
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

    const onCancelEdit = () => redirect(createPath({ resource: 'centers', type: 'list' }));

    return (
        <>
            <Container sx={editContainerStyles} maxWidth={false}>
                <ShsReturnButton
                    to={createPath({ resource: 'centers', type: 'list' })}
                    label="Назад до освітніх центрів"
                />
                <Edit mutationMode="pessimistic" queryOptions={{ meta: { useMock: false } }}>
                    <Typography variant="h4" component="h3" mb={4} fontWeight="700">
                        Редагування центру
                    </Typography>
                    <TabbedForm
                        toolbar={
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <ShsFormToolbar
                                    sx={shsButtonStyles}
                                    enableSaveButton={true}
                                    handleCancel={onCancelEdit}
                                    shouldCheckIfDirty={false}
                                />

                                <WithRole roles={[UserRole.SYSTEM_ADMIN]}>
                                    <ShsButton
                                        label="Видалити центр"
                                        sx={{
                                            marginTop: '2rem',
                                            whiteSpace: 'nowrap',
                                            padding: '0.75em 1.75em'
                                        }}
                                        styleType="outline-danger"
                                        icon={<DeleteIcon style={{ fill: '#F23030' }} />}
                                        onClick={() => setDeleteModalOpen(true)}
                                    />
                                </WithRole>
                            </Box>
                        }
                        defaultValues={centerDefaultValues}>
                        <TabbedForm.Tab label="Загальна інформація">
                            <TextInput sx={{ display: 'none' }} source={CenterFormFields.VERSION} name="version" />
                            <GeneralCenterInfo />
                            <CenterWorkingHours />
                            <CenterLessonsDuration
                                educationalLevel="Дошкільна освіта"
                                lessonDurationSource={`${CenterFormFields.LESSONS_DURATION}.${CenterFormFields.BEFORE_SCHOOL_EDUCATION}.${CenterFormFields.LESSON_DURATION}`}
                                schoolLessons={getSchoolLessons(CenterFormFields.BEFORE_SCHOOL_EDUCATION)}
                                isTitleShown
                            />
                            <CenterLessonsDuration
                                educationalLevel="1-4 класи"
                                lessonDurationSource={`${CenterFormFields.LESSONS_DURATION}.${CenterFormFields.FIRST_FOURTH_GRADE}.${CenterFormFields.LESSON_DURATION}`}
                                schoolLessons={getSchoolLessons(CenterFormFields.FIRST_FOURTH_GRADE)}
                            />
                            <CenterLessonsDuration
                                educationalLevel="5-11 класи"
                                lessonDurationSource={`${CenterFormFields.LESSONS_DURATION}.${CenterFormFields.FIFTH_TENTH_GRADE}.${CenterFormFields.LESSON_DURATION}`}
                                schoolLessons={getSchoolLessons(CenterFormFields.FIFTH_TENTH_GRADE)}
                            />
                        </TabbedForm.Tab>
                        <TabbedForm.Tab label="Відділення">
                            <CenterDepartment />
                        </TabbedForm.Tab>
                        <TabbedForm.Tab label="Місця проведення уроків">
                            <CenterLessonsPlace />
                        </TabbedForm.Tab>
                    </TabbedForm>
                    <DeleteEducationCenterModal isOpen={isDeleteModalOpen} onClose={() => setDeleteModalOpen(false)} />
                </Edit>
            </Container>
        </>
    );
};
